// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3YoOi","info":"PatientInfo_info__OBirm"};